import axiosInstance from "./axiosInstance";
// Save a mdo
export const saveMdoAPI = async (data) => {
  const res = await axiosInstance.post('/Dash/add_mdo', data);
  return res.data;
};

// Fetch mdo list
export const fetchMdoList = async (userInfo) => {
  const res = await axiosInstance.get('/Dash/usermaster', {
    params: {
      emp_code: userInfo.empCode,
      company_code: userInfo.company_code,
      user_role: userInfo.roleID,
      user_type: 'mdo'
    }
  });
  const raw = res.data?.data?.[0]?.get_user_data_by_type;
  return raw?.usermaster || [];
};